import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElDatePicker } from 'element-plus'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'CandidateDateRange',
  props: {
    modelValue: { default: null },
    rangeSeparator: { default: '-' },
    startPlaceholder: { default: '开始时间' },
    endPlaceholder: { default: '结束时间' },
    clearable: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDatePicker), _mergeProps({
    class: ["candidate-date-range", { 'is-filled': Boolean(_ctx.modelValue) }],
    "model-value": _ctx.modelValue,
    type: "daterange",
    "range-separator": _ctx.rangeSeparator,
    "start-placeholder": _ctx.startPlaceholder,
    "end-placeholder": _ctx.endPlaceholder,
    clearable: _ctx.clearable
  }, _ctx.$attrs, {
    "popper-class": ['candidate-date-range-popper', _ctx.$attrs['popper-class']],
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }), null, 16, ["class", "model-value", "range-separator", "start-placeholder", "end-placeholder", "clearable", "popper-class"]))
}
}

})